

/**
 * H5与native协议 js文件
 */
(function (win, $, UpSDK) {
    var apiStatus = {};
    var iframe = null;
    var urlPrefixCallAppInAndroid = 'uplivecn://goWindow'; // android调用外部协议
    var urlPrefixCallAppInIos = void 0;

    if (window.isUpVoice) {
        // 声播协议
        urlPrefixCallAppInIos = 'https://voice.upliveapps.com/goWindow'; // ios调用外部协议
    } else {
        urlPrefixCallAppInIos = 'https://ios.upliveapps.com/goWindow'; // ios调用外部协议
    }

    var native = {
        send: function send(url) {
            if (!iframe) {
                iframe = document.createElement('iframe');
                iframe.id = 'up_callapp_iframe_' + Date.now();
                iframe.frameborder = '0';
                iframe.style.cssText = 'display:none;border:0;width:0;height:0;';
                document.body.appendChild(iframe);
            }
            iframe.src = url;
        },
        sendUriScheme: function sendUriScheme(url) {
            window.location.href = url;
        },
        query: function query(name, scope) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
                scope = scope || 'search',
                r = location[scope].substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        },


        addParam: function addParam(url, data) {
            if (typeof data === 'undefined') {
                return;
            }

            var hashReg = /#.*$/gi,
                hashMatch = url.match(hashReg),
                hash = '';

            if (hashMatch) {
                hash = hashMatch[0];
            }

            // 去除hash值的url
            var preUrl = url.replace(hash, '');

            var searchReg = /\?(.*?)$/gi;
            var result = searchReg.exec(preUrl);
            var query;
            if (result) {
                query = result[1].split('#')[0];
            }

            var id = !query ? '' : '&';

            return preUrl + (query && query.length > 0 ? '' : '?') + (id + $.param(data)) + hash;
        },
        // 获得平台类型
        // weixin, weibo, qq, uplive，海外版本Android在URL Hash中添加标识 #pl=uplive
        getPlatform: function getPlatform() {
            var _ref = [navigator.userAgent, 'other'],
                ua = _ref[0],
                pl = _ref[1];


            if (ua.match(/uplive/i) || this.query('pl', 'hash') == 'uplive' || localStorage.getItem('__inuplive__') || this.query('pl') == 'uplive') {
                pl = 'uplive';
            } else if (ua.match(/micromessenger/i)) {
                pl = 'wechat';
            } else if (ua.match(/qq/i)) {
                pl = 'qq';
            } else if (ua.match(/weibo/i)) {
                pl = 'weibo';
            } else if (ua.match(/renren/i)) {
                pl = 'renren';
            } else if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) {
                pl = 'fb';
            } else if (ua.match(/Line/i)) {
                pl = 'line';
            }

            return pl;
        },


        // 获得当前系统类型
        getSystem: function getSystem() {
            var ua = navigator.userAgent;
            return (/(iPhone|iPad|iPod|iOS)/i.test(ua) ? 'ios' : /[aA]ndroid/i.test(ua) ? 'android' : 'pc'
            );
        },


        // 系统语言
        getLanguage: function getLanguage() {
            var language = navigator.language || navigator.browserLanguage;

            if (language) {
                var arr = language.split('-');
                arr[1] = arr[1].toUpperCase();
                language = arr.join('-');
            }

            return language;
        },


        // 检查api是否可用
        checkAvail: function checkAvail() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                apiname = _ref2.apiname,
                errtip = _ref2.errtip;

            setTimeout(function () {
                if (!apiStatus[apiname] && errtip) {
                    if (typeof errtip == 'function') {
                        errtip();
                    } else {
                        alert(errtip);
                    }
                }
            }, 3000);
        },

        /**
         * 获取配置信息
         * @param cfg {
         *      invalid 0: usertoken失效，重新获取；1：第一次获取
         *      complete: function(){}
         * }
         *
         */
        getConfigs: function getConfigs() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref3$complete = _ref3.complete,
                complete = _ref3$complete === undefined ? function () {} : _ref3$complete,
                _ref3$invalid = _ref3.invalid,
                invalid = _ref3$invalid === undefined ? 0 : _ref3$invalid,
                _ref3$errtip = _ref3.errtip,
                errtip = _ref3$errtip === undefined ? '不支持' : _ref3$errtip;

            var self = this;
            var url = 'uplive://getConfigs?json=';
            var params = {
                invalid: invalid,
                receive: "$['upliveapp_getConfigs']",
                jsCallback: '$.getConfigsComplete'
            };

            $.getConfigsComplete = function (param) {
                // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getConfigs',
                errtip: errtip
            });
        },


        /**
         * 获取主播信息
         * @param cfg {
         *      complete: function(){}
         * }
         *
         */
        getHostInfo: function getHostInfo() {
            var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref4$complete = _ref4.complete,
                complete = _ref4$complete === undefined ? function () {} : _ref4$complete,
                _ref4$errtip = _ref4.errtip,
                errtip = _ref4$errtip === undefined ? '不支持' : _ref4$errtip;

            var self = this;
            var url = 'uplive://getHostInfo?json=';
            var params = {
                receive: "$['upliveapp_getHostInfo']",
                jsCallback: '$.getHostInfoComplete'
            };

            $.getHostInfoComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getHostInfo',
                errtip: errtip
            });
        },


        // 上报提现结果给客户端
        acceptAgreement: function acceptAgreement() {
            var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref5$errtip = _ref5.errtip,
                errtip = _ref5$errtip === undefined ? '不支持' : _ref5$errtip;

            var url = 'uplive://acceptAgreement?json=';
            var params = {
                receive: "$['upliveapp_acceptAgreement']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'acceptAgreement',
                errtip: errtip
            });
        },

        /**
         * 跳转个人主页
         * @param cfg {
         *      uid: 10234, // {Number} 整型
                tab: 0：动态 1：关注 2：粉丝 3：守护
         * }
         */
        profile: function profile() {
            var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref6$uid = _ref6.uid,
                uid = _ref6$uid === undefined ? 0 : _ref6$uid,
                _ref6$tab = _ref6.tab,
                tab = _ref6$tab === undefined ? 0 : _ref6$tab,
                _ref6$errtip = _ref6.errtip,
                errtip = _ref6$errtip === undefined ? '' : _ref6$errtip,
                _ref6$action = _ref6.action,
                action = _ref6$action === undefined ? 'callapp' : _ref6$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'profile',
                extend: {
                    uid: parseInt(uid, 10),
                    tab: tab
                },
                receive: "$['upliveapp_profile']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'profile',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },

        /**
         * 跳转到直播间
         * @param cfg {
         *      uid: 10234, // {Number} 整型
         *      roomid: 10234 {Number} 整型
         * }
         */
        goRoom: function goRoom() {
            var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref7$uid = _ref7.uid,
                uid = _ref7$uid === undefined ? 0 : _ref7$uid,
                _ref7$roomid = _ref7.roomid,
                roomid = _ref7$roomid === undefined ? 0 : _ref7$roomid,
                _ref7$errtip = _ref7.errtip,
                errtip = _ref7$errtip === undefined ? '' : _ref7$errtip,
                _ref7$action = _ref7.action,
                action = _ref7$action === undefined ? 'callapp' : _ref7$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'room',
                extend: {
                    uid: parseInt(uid, 10),
                    roomid: parseInt(roomid, 10)
                },
                receive: "$['upliveapp_goRoom']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goRoom',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },
        goRank: function goRank() {
            var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref8$name = _ref8.name,
                name = _ref8$name === undefined ? 1 : _ref8$name,
                _ref8$errtip = _ref8.errtip,
                errtip = _ref8$errtip === undefined ? '' : _ref8$errtip,
                _ref8$action = _ref8.action,
                action = _ref8$action === undefined ? 'callapp' : _ref8$action;

            var url = 'uplive://goWindow?json=';
            var key = void 0;

            switch (parseInt(name, 10)) {
                case 1:
                    key = 'starank';
                    break;
                case 2:
                    key = 'hostrank';
                    break;
                case 3:
                    key = 'wealthrank';
                    break;
                default:
                    key = 'starank';
            }

            var params = {
                key: key,
                receive: "$['upliveapp_goRank']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goRank',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        // 跳转充值界面
        gopay: function gopay() {
            var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref9$errtip = _ref9.errtip,
                errtip = _ref9$errtip === undefined ? '' : _ref9$errtip,
                _ref9$complete = _ref9.complete,
                complete = _ref9$complete === undefined ? function () {} : _ref9$complete,
                _ref9$action = _ref9.action,
                action = _ref9$action === undefined ? 'callapp' : _ref9$action;

            var self = this;
            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'pay',
                receive: "$['upliveapp_gopay']",
                jsCallback: "$['getGopayComplete']"
            };

            $.getGopayComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'gopay',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        // 上报提现结果给客户端
        reportCashResult: function reportCashResult() {
            var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref10$success = _ref10.success,
                success = _ref10$success === undefined ? 1 : _ref10$success,
                errtip = _ref10.errtip;

            var url = 'uplive://h5cash?json=';
            var params = {
                success: success,
                receive: "$['upliveapp_reportCashResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportCashResult',
                errtip: errtip
            });
        },


        // 上报充值结果给客户端
        reportPayResult: function reportPayResult() {
            var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref11$success = _ref11.success,
                success = _ref11$success === undefined ? 1 : _ref11$success,
                errtip = _ref11.errtip;

            var url = 'uplive://h5payment?json=';
            var params = {
                success: success,
                receive: "$['upliveapp_reportPayResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportPayResult',
                errtip: errtip
            });
        },


        // 关闭webview
        closeWindow: function closeWindow() {
            var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref12$errtip = _ref12.errtip,
                errtip = _ref12$errtip === undefined ? '' : _ref12$errtip;

            var url = 'uplive://closeWindow?json=';
            var params = {
                receive: "$['upliveapp_closeWindow']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'closeWindow',
                errtip: errtip
            });
        },


        // 浏览器中打开
        openBrowser: function openBrowser() {
            var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref13$url = _ref13.url,
                url = _ref13$url === undefined ? '' : _ref13$url,
                _ref13$errtip = _ref13.errtip,
                errtip = _ref13$errtip === undefined ? '' : _ref13$errtip,
                _ref13$action = _ref13.action,
                action = _ref13$action === undefined ? 'callapp' : _ref13$action;

            var _url = 'uplive://openBrowser?json=';
            var params = {
                receive: "$['upliveapp_openBrowser']",
                url: url
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'openBrowser',
                    errtip: errtip
                });
            } else {
                return _url;
            }
        },

        // 打开新的webview
        openWebView: function openWebView() {
            var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref14$url = _ref14.url,
                url = _ref14$url === undefined ? '' : _ref14$url,
                _ref14$errtip = _ref14.errtip,
                errtip = _ref14$errtip === undefined ? '' : _ref14$errtip,
                _ref14$action = _ref14.action,
                action = _ref14$action === undefined ? 'callapp' : _ref14$action;

            var _url = 'uplive://openWebView?json=';
            var params = {
                receive: "$['upliveapp_openWebView']",
                url: url
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'openWebView',
                    errtip: errtip
                });
            } else {
                return _url;
            }
        },


        // 获取地理位置
        getLocation: function getLocation() {
            var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref15$complete = _ref15.complete,
                complete = _ref15$complete === undefined ? function () {} : _ref15$complete,
                _ref15$errtip = _ref15.errtip,
                errtip = _ref15$errtip === undefined ? '不支持' : _ref15$errtip;

            var self = this;
            var url = 'uplive://getLocation?json=';
            var params = {
                receive: "$['upliveapp_getLocation']",
                jsCallback: '$.getLocationComplete'
            };

            $.getLocationComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getLocation',
                errtip: errtip
            });
        },

        /**
         * 支付调用
         * @param data {object}
         *      - platform 支付平台
         *      - complete {function}
         *      - params 参数
         * @return this
         */
        pay: function pay() {
            var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref16$complete = _ref16.complete,
                complete = _ref16$complete === undefined ? function () {} : _ref16$complete,
                _ref16$platform = _ref16.platform,
                platform = _ref16$platform === undefined ? 'wxpay' : _ref16$platform,
                _ref16$productId = _ref16.productId,
                productId = _ref16$productId === undefined ? '' : _ref16$productId,
                _ref16$errtip = _ref16.errtip,
                errtip = _ref16$errtip === undefined ? '不支持支付' : _ref16$errtip;

            var self = this;
            var _url = 'uplive://payment?json=';
            var _params = {
                receive: "$['upliveapp_pay']",
                platform: platform || 'wxpay',
                params: {
                    productId: productId
                },
                jsCallback: '$.payComplete'
            };

            $.payComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'pay',
                errtip: errtip
            });
        },
        ynpay: function ynpay() {
            var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref17$complete = _ref17.complete,
                complete = _ref17$complete === undefined ? function () {} : _ref17$complete,
                _ref17$platform = _ref17.platform,
                platform = _ref17$platform === undefined ? 'wxpay' : _ref17$platform,
                _ref17$productId = _ref17.productId,
                productId = _ref17$productId === undefined ? '' : _ref17$productId,
                _ref17$orderStr = _ref17.orderStr,
                orderStr = _ref17$orderStr === undefined ? '' : _ref17$orderStr,
                _ref17$orderId = _ref17.orderId,
                orderId = _ref17$orderId === undefined ? '' : _ref17$orderId,
                _ref17$errtip = _ref17.errtip,
                errtip = _ref17$errtip === undefined ? '不支持支付' : _ref17$errtip;

            var self = this;
            var _url = 'uplive://ynzf?json=';
            var _params = {
                receive: "$['upliveapp_ynpay']",
                platform: platform || 'wxpay',
                params: {
                    orderId: orderId + '',
                    productId: productId + '',
                    orderStr: orderStr
                },
                jsCallback: '$.payComplete'
            };

            $.payComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'ynpay',
                errtip: errtip
            });
        },
        checkRepairOrder: function checkRepairOrder() {
            var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref18$complete = _ref18.complete,
                complete = _ref18$complete === undefined ? function () {} : _ref18$complete,
                _ref18$errtip = _ref18.errtip,
                errtip = _ref18$errtip === undefined ? '' : _ref18$errtip;

            var self = this;
            var url = 'uplive://checkRepairOrder?json=';
            var params = {
                receive: "$['upliveapp_checkRepairOrder']",
                jsCallback: '$.checkRepairOrderComplete'
            };

            $.checkRepairOrderComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'checkRepairOrder',
                errtip: errtip
            });
        },
        goRepairOrder: function goRepairOrder() {
            var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref19$complete = _ref19.complete,
                complete = _ref19$complete === undefined ? function () {} : _ref19$complete,
                _ref19$errtip = _ref19.errtip,
                errtip = _ref19$errtip === undefined ? '' : _ref19$errtip;

            var url = 'uplive://goRepairOrder?json=';
            var params = {
                receive: "$['upliveapp_goRepairOrder']",
                jsCallback: '$.goRepairOrderComplete'
            };

            $.goRepairOrderComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goRepairOrder',
                errtip: errtip
            });
        },

        // 通过相机获取图片
        getPhotoCamera: function getPhotoCamera() {
            var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref20$complete = _ref20.complete,
                complete = _ref20$complete === undefined ? function () {} : _ref20$complete,
                _ref20$type = _ref20.type,
                type = _ref20$type === undefined ? "share" : _ref20$type,
                _ref20$crop = _ref20.crop,
                crop = _ref20$crop === undefined ? 0 : _ref20$crop,
                _ref20$width = _ref20.width,
                width = _ref20$width === undefined ? 640 : _ref20$width,
                _ref20$height = _ref20.height,
                height = _ref20$height === undefined ? 640 : _ref20$height,
                _ref20$errtip = _ref20.errtip,
                errtip = _ref20$errtip === undefined ? '不支持' : _ref20$errtip;

            var self = this;
            var url = 'uplive://getPhoto?json=';
            var params = {
                type: type || 'share',
                sourceType: "camera", //图片来源，照相机
                crop: crop,
                width: width,
                height: height,
                receive: "$['upliveapp_getPhotoCamera']",
                jsCallback: '$.getPhotoCameraComplete'
            };

            $.getPhotoCameraComplete = function (param) {
                // "url":"网络链接"
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getPhotoCamera',
                errtip: errtip
            });
        },

        // 通过图库获取图片
        getPhotoAlbum: function getPhotoAlbum() {
            var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref21$complete = _ref21.complete,
                complete = _ref21$complete === undefined ? function () {} : _ref21$complete,
                _ref21$type = _ref21.type,
                type = _ref21$type === undefined ? "share" : _ref21$type,
                _ref21$crop = _ref21.crop,
                crop = _ref21$crop === undefined ? 0 : _ref21$crop,
                _ref21$width = _ref21.width,
                width = _ref21$width === undefined ? 640 : _ref21$width,
                _ref21$height = _ref21.height,
                height = _ref21$height === undefined ? 640 : _ref21$height,
                _ref21$errtip = _ref21.errtip,
                errtip = _ref21$errtip === undefined ? '不支持' : _ref21$errtip;

            var self = this;
            var url = 'uplive://getPhoto?json=';
            var params = {
                type: type || 'share',
                sourceType: "album", //图片来源，照相机
                crop: crop,
                width: width,
                height: height,
                receive: "$['upliveapp_getPhotoAlbum']",
                jsCallback: '$.getPhotoAlbumComplete'
            };

            $.getPhotoAlbumComplete = function (param) {
                // "url":"网络链接"
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getPhotoAlbum',
                errtip: errtip
            });
        },


        // 客户端分享
        share: function share() {
            var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref22$complete = _ref22.complete,
                complete = _ref22$complete === undefined ? function () {} : _ref22$complete,
                _ref22$title = _ref22.title,
                title = _ref22$title === undefined ? '分享标题' : _ref22$title,
                _ref22$url = _ref22.url,
                url = _ref22$url === undefined ? 'http://www.baidu.com' : _ref22$url,
                _ref22$imageUrl = _ref22.imageUrl,
                imageUrl = _ref22$imageUrl === undefined ? 'https://m.baidu.com/static/index/plus/plus_logo.png' : _ref22$imageUrl,
                _ref22$desc = _ref22.desc,
                desc = _ref22$desc === undefined ? '分享表述' : _ref22$desc,
                _ref22$platform = _ref22.platform,
                platform = _ref22$platform === undefined ? {} : _ref22$platform,
                _ref22$errtip = _ref22.errtip,
                errtip = _ref22$errtip === undefined ? '客户端不支持分享' : _ref22$errtip;

            var self = this;
            var _url = 'uplive://sharePage?json=';
            var pls = ['qq', 'qzone', 'wechat_friends', 'wechat_circle', 'sina', 'fb', 'tw'];
            var oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            var params = {
                receive: "$['upliveapp_share']",
                platform: {},
                jsCallback: '$.upliveShareComplete'
            };

            pls.forEach(function (item, i) {
                params.platform[item] = {
                    url: url,
                    title: title,
                    imageUrl: imageUrl,
                    desc: desc
                };
            });

            if (JSON.stringify(platform) != '{}') {
                params = $.extend(true, params, {
                    platform: platform
                });
            }

            for (var i in params) {
                if (i == 'platform') {
                    for (var j in params[i]) {
                        for (var k in params[i][j]) {
                            if (k == 'title' || k == 'desc') {
                                params[i][j][k] = encodeURIComponent(params[i][j][k]);
                            }
                            if (k == 'url' && params[i][j][k] && oauthtype[j]) {
                                var _url2 = params[i][j][k];

                                params[i][j][k] = this.addParam(_url2, {
                                    oauthtype: oauthtype[j]
                                });
                            }
                        }
                    }
                }
            }

            $.upliveShareComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(_url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'share',
                errtip: errtip
            });
        },


        // 单渠道分享
        singleShare: function singleShare() {
            var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref23$complete = _ref23.complete,
                complete = _ref23$complete === undefined ? function () {} : _ref23$complete,
                _ref23$title = _ref23.title,
                title = _ref23$title === undefined ? '分享标题' : _ref23$title,
                _ref23$url = _ref23.url,
                url = _ref23$url === undefined ? 'http://www.baidu.com' : _ref23$url,
                _ref23$imageUrl = _ref23.imageUrl,
                imageUrl = _ref23$imageUrl === undefined ? 'https://m.baidu.com/static/index/plus/plus_logo.png' : _ref23$imageUrl,
                _ref23$desc = _ref23.desc,
                desc = _ref23$desc === undefined ? '分享表述' : _ref23$desc,
                _ref23$type = _ref23.type,
                type = _ref23$type === undefined ? 'fb' : _ref23$type,
                _ref23$errtip = _ref23.errtip,
                errtip = _ref23$errtip === undefined ? '客户端不支持分享' : _ref23$errtip,
                _ref23$action = _ref23.action,
                action = _ref23$action === undefined ? 'callapp' : _ref23$action;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://singleShare?json=';
            var pls = ["qq", "qzone", "wechat_friends", "wechat_circle", "sina", "fb", "tw", "messenger", "whatsapp", "ins", "line", "kakao"];
            var oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            if (url && oauthtype[type]) {
                url = this.addParam(url, {
                    oauthtype: oauthtype[type]
                });
            }
            if (type == 'sina') {
                desc += '>>' + url;
            }
            var params = {
                receive: "$['upliveapp_singleShare']",
                platform: {
                    url: url,
                    title: system == 'ios' ? title : encodeURIComponent(title),
                    imageUrl: imageUrl,
                    desc: system == 'ios' ? desc : encodeURIComponent(desc)
                },
                type: type,
                jsCallback: '$.upliveSingleShareComplete'
            };

            $.upliveSingleShareComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'singleShare',
                    errtip: errtip
                });
            } else {
                return _url;
            }
        },


        // 1.6.5 根据国家码跳转到国家主播列表
        goHotListByArea: function goHotListByArea() {
            var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref24$countryCode = _ref24.countryCode,
                countryCode = _ref24$countryCode === undefined ? '' : _ref24$countryCode,
                _ref24$errtip = _ref24.errtip,
                errtip = _ref24$errtip === undefined ? '' : _ref24$errtip;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'hotbyarea',
                extend: {
                    countryCode: countryCode
                },
                receive: "$['upliveapp_goHotListByArea']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goHotListByArea',
                errtip: errtip
            });
        },

        /*--------------------- V2.0.0 -------------------*/

        // 游客登录
        login: function login() {
            var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref25$complete = _ref25.complete,
                complete = _ref25$complete === undefined ? function () {} : _ref25$complete,
                _ref25$errtip = _ref25.errtip,
                errtip = _ref25$errtip === undefined ? '不支持登录' : _ref25$errtip;

            var self = this;
            var url = 'uplive://goLogin?json=';
            var params = {
                receive: "$['upliveapp_login']",
                jsCallback: '$.loginComplete'
            };
            $.loginComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'login',
                errtip: errtip
            });
        },


        // 刷新用户信息
        refreshProfile: function refreshProfile() {
            var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref26$errtip = _ref26.errtip,
                errtip = _ref26$errtip === undefined ? '不支持刷新用户信息' : _ref26$errtip;

            var url = 'uplive://refreshProfile?json=';
            var params = {
                receive: "$['upliveapp_refreshProfile']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'refreshProfile',
                errtip: errtip
            });
        },


        /* -------------------- ios 我的收益 --------------------- */

        goCashRecord: function goCashRecord() {
            var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref27$errtip = _ref27.errtip,
                errtip = _ref27$errtip === undefined ? '不支持领取纪录' : _ref27$errtip;

            var url = 'uplive://goCashRecord?json=';
            var params = {
                receive: "$['upliveapp_goCashRecord']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goCashRecord',
                errtip: errtip
            });
        },
        bindMobilePhone: function bindMobilePhone() {
            var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref28$complete = _ref28.complete,
                complete = _ref28$complete === undefined ? function () {} : _ref28$complete,
                _ref28$errtip = _ref28.errtip,
                errtip = _ref28$errtip === undefined ? '不支持手机绑定' : _ref28$errtip;

            var self = this;
            var url = 'uplive://bindMobilePhone?json=';
            var params = {
                receive: "$['upliveapp_bindMobilePhone']",
                jsCallback: '$.bindMobilePhoneComplete'
            };
            $.bindMobilePhoneComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindMobilePhone',
                errtip: errtip
            });
        },
        bindWechat: function bindWechat() {
            var _ref29 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref29$complete = _ref29.complete,
                complete = _ref29$complete === undefined ? function () {} : _ref29$complete,
                _ref29$errtip = _ref29.errtip,
                errtip = _ref29$errtip === undefined ? '不支持微信绑定' : _ref29$errtip;

            var self = this;
            var url = 'uplive://bindWechat?json=';
            var params = {
                receive: "$['upliveapp_bindWechat']",
                jsCallback: '$.bindWechatComplete'
            };
            $.bindWechatComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindWechat',
                errtip: errtip
            });
        },
        setTitle: function setTitle() {
            var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref30$title = _ref30.title,
                title = _ref30$title === undefined ? '' : _ref30$title,
                _ref30$errtip = _ref30.errtip,
                errtip = _ref30$errtip === undefined ? function () {} : _ref30$errtip;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://setTitle?json=';
            var _params = {
                receive: "$['upliveapp_setTitle']",
                params: {
                    title: title
                }
            };

            if (system == 'android') {
                document.title = title;
            } else {
                this.send(_url + JSON.stringify(_params));
                this.checkAvail({
                    apiname: 'setTitle',
                    errtip: errtip
                });
            }
        },


        /**
         * 设置客户端导航
         */
        setNavBar: function setNavBar() {
            var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref31$backgroundColo = _ref31.backgroundColor,
                backgroundColor = _ref31$backgroundColo === undefined ? '#FFFFFF' : _ref31$backgroundColo,
                _ref31$skin = _ref31.skin,
                skin = _ref31$skin === undefined ? 0 : _ref31$skin,
                _ref31$iconPath = _ref31.iconPath,
                iconPath = _ref31$iconPath === undefined ? '' : _ref31$iconPath,
                _ref31$pagePath = _ref31.pagePath,
                pagePath = _ref31$pagePath === undefined ? '' : _ref31$pagePath,
                _ref31$errtip = _ref31.errtip,
                errtip = _ref31$errtip === undefined ? function () {} : _ref31$errtip;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://setNavBar?json=';
            var _params = {
                receive: "$['upliveapp_setNavBar']",
                params: {
                    backgroundColor: backgroundColor, // 十六进制
                    skin: skin, // 0: 默认紫色back + 黑色文本；1: 白色back + 白色文本
                    iconPath: iconPath, // 图片路径
                    pagePath: pagePath // 点击icon的页面路径

                }
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'setNavBar',
                errtip: errtip
            });
        },

        /* ----------------------V 2.6.0 -------------------*/
        /**
         * 跳转到开播准备页面
         * @param cfg {
         * }
         */
        goReadyToLive: function goReadyToLive() {
            var _ref32 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref32$errtip = _ref32.errtip,
                errtip = _ref32$errtip === undefined ? '' : _ref32$errtip,
                _ref32$action = _ref32.action,
                action = _ref32$action === undefined ? 'callapp' : _ref32$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'readyToLive',
                receive: "$['upliveapp_goReadyToLive']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goReadyToLive',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到我的背包页面
         * @param cfg {
         * }
         */
        goPack: function goPack() {
            var _ref33 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref33$errtip = _ref33.errtip,
                errtip = _ref33$errtip === undefined ? '' : _ref33$errtip,
                _ref33$action = _ref33.action,
                action = _ref33$action === undefined ? 'callapp' : _ref33$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'pack',
                receive: "$['upliveapp_goPack']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goPack',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到发现列表
         * @param cfg {
         * }
         */
        goFindList: function goFindList() {
            var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref34$errtip = _ref34.errtip,
                errtip = _ref34$errtip === undefined ? '' : _ref34$errtip,
                _ref34$action = _ref34.action,
                action = _ref34$action === undefined ? 'callapp' : _ref34$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'findList',
                receive: "$['upliveapp_goFindList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goFindList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到热门列表
         * @param cfg {
         * }
         */
        goHotList: function goHotList() {
            var _ref35 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref35$errtip = _ref35.errtip,
                errtip = _ref35$errtip === undefined ? '' : _ref35$errtip,
                _ref35$action = _ref35.action,
                action = _ref35$action === undefined ? 'callapp' : _ref35$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'hotList',
                receive: "$['upliveapp_goHotList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goHotList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到VIP特权页面
         * @param cfg {
         * }
         */
        goVipPrivileges: function goVipPrivileges() {
            var _ref36 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref36$errtip = _ref36.errtip,
                errtip = _ref36$errtip === undefined ? '' : _ref36$errtip;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'vipPrivileges',
                receive: "$['upliveapp_goVipPrivileges']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goVipPrivileges',
                errtip: errtip
            });
        },


        /**
        * 跳转到VIP特权设置页面
        * @param cfg {
        * }
        */
        goVipPrivilegesSetting: function goVipPrivilegesSetting() {
            var _ref37 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref37$errtip = _ref37.errtip,
                errtip = _ref37$errtip === undefined ? '' : _ref37$errtip,
                _ref37$action = _ref37.action,
                action = _ref37$action === undefined ? 'callapp' : _ref37$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'vipPrivilegesSetting',
                receive: "$['upliveapp_goVipPrivilegesSetting']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goVipPrivilegesSetting',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转开通守护
         * uid  主播id
         * roomId 直播间id
         * complete 回调方法
         */
        goOpenGuard: function goOpenGuard() {
            var _ref38 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref38$uid = _ref38.uid,
                uid = _ref38$uid === undefined ? 0 : _ref38$uid,
                _ref38$roomId = _ref38.roomId,
                roomId = _ref38$roomId === undefined ? 0 : _ref38$roomId,
                _ref38$complete = _ref38.complete,
                complete = _ref38$complete === undefined ? function () {} : _ref38$complete,
                _ref38$errtip = _ref38.errtip,
                errtip = _ref38$errtip === undefined ? '' : _ref38$errtip,
                _ref38$action = _ref38.action,
                action = _ref38$action === undefined ? 'callapp' : _ref38$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'openGuard',
                extend: {
                    uid: uid,
                    roomid: roomId
                },
                receive: "$['upliveapp_goOpenGuard']",
                "jsCallback": "$.buyOpenGuardComplete"
            };

            $.buyOpenGuardComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goOpenGuard',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         *
         * 跳转IM聊天
         * uid  主播id
         *
         */

        openChat: function openChat() {
            var _ref39 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref39$uid = _ref39.uid,
                uid = _ref39$uid === undefined ? 10005 : _ref39$uid,
                _ref39$errtip = _ref39.errtip,
                errtip = _ref39$errtip === undefined ? '' : _ref39$errtip,
                _ref39$action = _ref39.action,
                action = _ref39$action === undefined ? 'callapp' : _ref39$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'openChat',
                extend: {
                    uid: uid
                },
                receive: "$['upliveapp_openChat']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'openChat',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到关注列表
         * @param cfg {
         * }
         */
        goFollowList: function goFollowList() {
            var _ref40 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref40$errtip = _ref40.errtip,
                errtip = _ref40$errtip === undefined ? '' : _ref40$errtip,
                _ref40$action = _ref40.action,
                action = _ref40$action === undefined ? 'callapp' : _ref40$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'followList',
                receive: "$['upliveapp_goFollowList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goFollowList',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到短视频录制准备页面；
         * @param cfg {
                topic: 话题,
                topicId: 话题id {int}
         * }
         */
        goReadyToShortVideo: function goReadyToShortVideo() {
            var _ref41 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref41$topic = _ref41.topic,
                topic = _ref41$topic === undefined ? '' : _ref41$topic,
                _ref41$topicId = _ref41.topicId,
                topicId = _ref41$topicId === undefined ? '' : _ref41$topicId,
                _ref41$errtip = _ref41.errtip,
                errtip = _ref41$errtip === undefined ? '' : _ref41$errtip,
                _ref41$action = _ref41.action,
                action = _ref41$action === undefined ? 'callapp' : _ref41$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'readyToShortVideo',
                extend: {
                    topic: topic,
                    topicId: parseInt(topicId, 10)
                },
                receive: "$['upliveapp_goReadyToShortVideo']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goReadyToShortVideo',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到指定短视频页面&播放视频
         * @param cfg {
                rid: '主帖子ID', ［必须］
                dynamicId: '动态ID',［必须］
                dynamicType: "动态类型",［必须］
                // ［非必须］
                resourceUrls: {}, // 图片或者视频地址
                resourceDesp: "" // 资源描述信息
         * }
         */
        goDynamic: function goDynamic() {
            var _ref42 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref42$rid = _ref42.rid,
                rid = _ref42$rid === undefined ? '' : _ref42$rid,
                _ref42$dynamicId = _ref42.dynamicId,
                dynamicId = _ref42$dynamicId === undefined ? '' : _ref42$dynamicId,
                _ref42$dynamicType = _ref42.dynamicType,
                dynamicType = _ref42$dynamicType === undefined ? '' : _ref42$dynamicType,
                _ref42$resourceUrls = _ref42.resourceUrls,
                resourceUrls = _ref42$resourceUrls === undefined ? null : _ref42$resourceUrls,
                _ref42$resourceDesp = _ref42.resourceDesp,
                resourceDesp = _ref42$resourceDesp === undefined ? '' : _ref42$resourceDesp,
                _ref42$errtip = _ref42.errtip,
                errtip = _ref42$errtip === undefined ? '' : _ref42$errtip;

            var url = 'uplive://goWindow?json=';
            var _params = {
                rid: rid,
                dynamicId: dynamicId,
                dynamicType: dynamicType
            };

            if (resourceUrls) {
                _params.resourceUrls = resourceUrls;
                _params.resourceDesp = resourceDesp;
            }
            var params = {
                key: 'dynamic',
                extend: _params,
                receive: "$['upliveapp_goDynamic']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goDynamic',
                errtip: errtip
            });
        },


        /* ----------------------V ios 2.5.0 -------------------*/

        /**
         * 跳转到座驾商场
         * @param cfg {
         * }
         */
        goCarMall: function goCarMall() {
            var _ref43 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref43$errtip = _ref43.errtip,
                errtip = _ref43$errtip === undefined ? '' : _ref43$errtip,
                _ref43$action = _ref43.action,
                action = _ref43$action === undefined ? 'callapp' : _ref43$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'carmall',
                receive: "$['upliveapp_goCarMall']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goCarMall',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /**
         * 跳转到我的座驾
         * @param cfg {
         * }
         */
        goMyCar: function goMyCar() {
            var _ref44 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref44$errtip = _ref44.errtip,
                errtip = _ref44$errtip === undefined ? '' : _ref44$errtip,
                _ref44$action = _ref44.action,
                action = _ref44$action === undefined ? 'callapp' : _ref44$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'mycar',
                receive: "$['upliveapp_goMyCar']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goMyCar',
                    errtip: errtip
                });
            } else {
                return url;
            }
        },


        /*--------------------- 外部协议 -------------------*/
        // 打开链接
        openUrlCallApp: function openUrlCallApp() {
            var _ref45 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref45$url = _ref45.url,
                url = _ref45$url === undefined ? '' : _ref45$url;

            var system = this.getSystem();
            var _url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                _url = urlPrefixCallAppInAndroid + '/webview?json=';;
            }

            var params = {
                key: 'webview',
                url: url
            };
            this.sendUriScheme(_url + encodeURIComponent(JSON.stringify(params)));
        },


        // 进入用户主页
        profileCallApp: function profileCallApp() {
            var _ref46 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref46$uid = _ref46.uid,
                uid = _ref46$uid === undefined ? 0 : _ref46$uid;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/profile?json=';;
            }
            var params = {
                key: 'profile',
                extend: {
                    uid: parseInt(uid, 10)
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },


        // 进入充值页
        goPayCallApp: function goPayCallApp() {
            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/pay?json=';
            }
            var params = {
                key: 'pay'
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },


        // 直播间
        goRoomCallApp: function goRoomCallApp() {
            var _ref47 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref47$uid = _ref47.uid,
                uid = _ref47$uid === undefined ? 0 : _ref47$uid,
                _ref47$roomid = _ref47.roomid,
                roomid = _ref47$roomid === undefined ? 0 : _ref47$roomid;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/room?json=';
            }
            var params = {
                key: 'room',
                extend: {
                    uid: parseInt(uid, 10),
                    roomid: parseInt(roomid, 10)
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },

        // 榜单页 1 星榜，2主播榜，3财富榜
        goRankCallApp: function goRankCallApp() {
            var _ref48 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref48$name = _ref48.name,
                name = _ref48$name === undefined ? 1 : _ref48$name;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/rank?json=';
            }
            var key = void 0;

            switch (parseInt(name, 10)) {
                case 1:
                    key = 'starank';
                    break;
                case 2:
                    key = 'hostrank';
                    break;
                case 3:
                    key = 'wealthrank';
                    break;
                default:
                    key = 'starank';
            }
            var params = {
                key: key
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },

        // 1.6.5 根据国家码跳转到国家主播列表
        goHotListByAreaCallApp: function goHotListByAreaCallApp() {
            var _ref49 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref49$countryCode = _ref49.countryCode,
                countryCode = _ref49$countryCode === undefined ? '' : _ref49$countryCode;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/hotbyarea?json=';
            }
            var params = {
                key: 'hotbyarea',
                extend: {
                    countryCode: countryCode
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },

        /**
         * 发送GIFTO礼物
         * @param cfg {
         *      data {}；发送礼物的详细信息
         *      complete: function(){}
         * }
         *      uplive://sendGTOGift?json={
         *              "jsCallback": ""
         *              ,receive:""
         *              ,"data":"{
         *                  //接收礼物用户uid
         *                  "sendtoUid":"",
         *                  // 消息内容
         *                  "content": "1";
         *                  //礼物ID 必填
         *                  "giftId": "2";
         *                  //礼物名称
         *                  "giftName" : "3";
         *                  //连发系数
         *                  "giftAmount": "4";
         *                  //是否连续
         *                  "isContinuous": "5";
         *                  //连续次数 必填
         *                  "numContinuous": "6";
         *                  //礼物大图
         *                  "giftBigPicUrl": "6";
         *              }"}
         *
         */
        sendGTOGift: function sendGTOGift() {
            var _ref50 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref50$complete = _ref50.complete,
                complete = _ref50$complete === undefined ? function () {} : _ref50$complete,
                _ref50$data = _ref50.data,
                data = _ref50$data === undefined ? {} : _ref50$data,
                _ref50$errtip = _ref50.errtip,
                errtip = _ref50$errtip === undefined ? '不支持' : _ref50$errtip;

            var self = this;
            var url = 'uplive://sendGTOGift?json=';
            var params = {
                receive: "$['upliveapp_sendGTOGift']",
                jsCallback: '$.sendGiftoGiftComplete',
                data: data
            };

            $.sendGiftoGiftComplete = function (param) {
                // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'sendGTOGift',
                errtip: errtip
            });
        },

        /**
         * 通过面板的id和礼物的id选中礼物
         * @param data
         * @param errtip
         */
        selectGift: function selectGift(_ref51) {
            var _ref51$data = _ref51.data,
                data = _ref51$data === undefined ? {} : _ref51$data,
                _ref51$errtip = _ref51.errtip,
                errtip = _ref51$errtip === undefined ? '不支持' : _ref51$errtip;

            var url = 'uplive://selectGift?json=';
            var params = {
                receive: "$['upliveapp_selectGift']",
                params: {
                    giftId: data.giftId,
                    labelId: data.labelId
                }
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'selectGift',
                errtip: errtip
            });
        }
    };

    var _loop = function _loop(i) {
        $['upliveapp_' + i] = function () {
            apiStatus[i] = 1;
        };
    };

    for (var i in native) {
        _loop(i);
    }

    window.UpSDK = native;

    if (typeof module != 'undefined' && module.exports) {
        module.exports = native;
    } else {
        window.UpSDK = native;
    }

    if (window.define && define.cmd) {
        define(function (require, exports, module) {
            module.exports = native;
        });
    }
})(window, window.Zepto || window.jQuery || (window['$'] = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-up-native/dist/index.js
// module id = 358
// module chunks = 0